export default "__VITE_ASSET__Hbrh$K3t__"